export default __webpack_public_path__ + "static/media/breakfast.4bea8dc5.jpg";